import * as THREE from 'three'

import Debug from './Utils/Debug.js'
import Sizes from './Utils/Sizes.js'
import Time from './Utils/Time.js'
import Camera from './Camera.js'
import Renderer from './Renderer.js'
import World from './World/World.js'
import Resources from './Utils/Resources.js'
import sources from './sources.js'
import Statistics from './Utils/Statistics.js'

let instance = null

export default class Experience {
  constructor (_canvas) {
    // Singleton
    if (instance) return instance

    instance = this

    // Global access
    window.experience = this

    // Options
    this.canvas = _canvas

    // Setup
    this.debug = new Debug()
    this.raycaster = new THREE.Raycaster()
    this.sizes = new Sizes()
    this.time = new Time()
    this.scene = new THREE.Scene()

    this.resources = new Resources(sources)
    this.camera = new Camera()
    this.renderer = new Renderer()

    // this.renderer = new Renderer()

    // this.mouse = (new Mouse()).mouse
    document
      .querySelector('.home__start-button')
      .addEventListener('click', () => {
        setTimeout(() => {
          this.world = new World()
        }, 1000)
      })
    this.statistics = new Statistics()
    // Resize event
    this.sizes.on('resize', () => {
      this.resize()
    })

    // Time tick event
    this.time.on('tick', () => {
      this.update()
    })
  }

  resize () {
    this.camera.resize()
    this.renderer.resize()
  }

  update () {
    this.statistics.stats.begin()
    if (this.camera) this.camera.update()
    if (this.world) this.world.update()
    if (this.renderer) this.renderer.update()
    this.statistics.stats.end()
  }

  destroy () {
    this.sizes.off('resize')
    this.time.off('tick')

    // Traverse the whole scene
    this.scene.traverse((child) => {
      // Test if it's a mesh
      if (child instanceof THREE.Mesh) {
        child.geometry.dispose()

        // Loop through the material properties
        for (const key in child.material) {
          const value = child.material[key]

          // Test if there is a dispose function
          if (value && typeof value.dispose === 'function') value.dispose()
        }
      }
    })

    this.camera.controls.dispose()
    this.renderer.instance.dispose()

    if (this.debug.active) this.debug.ui.destroy()
  }
}
